import { LoadingView } from '../../../../components/LoadingView'
// api
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { useState, useMemo } from 'react'
import { SIZE, SHAPE, } from 'baseui/button-group';
import { Block } from 'baseui/block';
import { Button, KIND } from "baseui/button";
import { GroupSelection } from '../../GroupSelection';
import { FormattedMessage } from 'react-intl';
import { schema as schemaPFloor } from '../P_Floor'
import { schema as schemaPRoomAutomation } from '../P_RoomAutomation'
import { useStyletron } from 'baseui';
import { schema as EdegeDeviceSchema } from '../../../Devices/EdgeDevice'
import { schema as BacnetDeviceSchema } from '../../../Devices/BacnetDevice'
import { schema as HeatmapBuildingSchema } from '../../../ReportsAndStatistics/Energy/HeatmapBuilding/types'
import { AutomationObjectsFlexGridView } from '../../../components/Grid/AutomationObjectsFlexGridView';
import { IAutomationObject } from '../../../types';
import { schema as schemaAHU } from '../../AirHandlingUnits/P_AirHandlingUnit/types'
import { schema as schemaHeatingGen } from '../../Heatings/P_HeatingGenerator/types'
import { schema as schemaHeatingOutlet } from '../../Heatings/P_HeatingOutlet/types'
import { schema as schemaHeatingCoolingOutlet } from '../../HeatingCoolings/P_HeatingCoolingOutlet/types'
import { schema as schemaHeatingPuffer } from '../../Heatings/P_HeatingPuffer/types'
import { schema as schemaCoolingGenerator } from '../../Coolings/P_CoolingGenerator/types'
import { schema as schemaCoolinOutlet } from '../../Coolings/P_CoolingOutlet/types'
import { schema as schemaEOV } from '../../../Utils/EnergyOverview/types'
import { NotificationCircle } from 'baseui/badge';

interface ISortPrioDictionary {
    [index: string]: number;
}
const sortPrios: ISortPrioDictionary = {
    [schemaEOV]: 0,
    [schemaPRoomAutomation]: 1,
    [schemaHeatingGen]: 2,
    [schemaCoolingGenerator]: 3,
    [schemaHeatingPuffer]: 4,
    [schemaHeatingOutlet]: 5,
    [schemaHeatingCoolingOutlet]: 6,
    [schemaCoolinOutlet]: 7,
    [schemaAHU]: 8,
}

export function ChildrenViewBySchema(props: { filter?: (app: any) => boolean | undefined, parentId: string, resourceGroupId: string, defaultGroup: GroupSelection }) {
    const [, theme] = useStyletron();
    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(props.resourceGroupId, props.parentId);


    const [heat, setHeat] = useState(props.defaultGroup === GroupSelection.Heat);
    const onHeatChanged = () => { heat ? setHeat(false) : setHeat(true); setAll(false); setCool(false); setVentilation(false); setCommon(false); setRoom(false); };
    const [cool, setCool] = useState(props.defaultGroup === GroupSelection.Cool);
    const onCoolChanged = () => { cool ? setCool(false) : setCool(true); setAll(false); setHeat(false); setVentilation(false); setCommon(false); setRoom(false); };
    const [ventilation, setVentilation] = useState(props.defaultGroup === GroupSelection.Ventilation);
    const onVentilationChanged = () => { ventilation ? setVentilation(false) : setVentilation(true); setAll(false); setHeat(false); setCool(false); setCommon(false); setRoom(false); };
    const [room, setRoom] = useState(props.defaultGroup === GroupSelection.Room);
    const onRoomChanged = () => { room ? setRoom(false) : setRoom(true); setAll(false); setHeat(false); setCool(false); setCommon(false); setVentilation(false); };
    const [common, setCommon] = useState(props.defaultGroup === GroupSelection.Common);
    const onCommonChanged = () => { common ? setCommon(false) : setCommon(true); setAll(false); setHeat(false); setCool(false); setRoom(false); setVentilation(false); };
    const [all, setAll] = useState(props.defaultGroup === GroupSelection.All);
    const onAllChanged = () => {
        all ? setAll(false) : setAll(true);
        setHeat(false);
        setCool(false);
        setVentilation(false);
        setRoom(false);
        setCommon(false);
    };

    

    const extFilter = props.filter;
    const basicFilteredItems = useMemo(() => (extFilter ? children?.filter((a) => extFilter(a)) : children)?.filter((a) => (a.schema !== EdegeDeviceSchema && a.schema !== BacnetDeviceSchema &&  a.schema !== HeatmapBuildingSchema)), [children, extFilter]);
    const length = basicFilteredItems?.length ?? 0;
    const hideButtons = length < 6;

    const filterdItems = useMemo(() => {
        const items = basicFilteredItems;
        if (hideButtons || all) {
            return items?.sort(sortBySchema);
        }
        else {
            return items?.filter((a) => (
                cool && a.schema?.toLowerCase().includes('cool'))
                || (heat && a.schema?.toLowerCase().includes('heat'))
                || (ventilation && a.schema?.toLowerCase().includes('air'))
                || (room && (a.schema === schemaPRoomAutomation || a.schema === schemaPFloor))
                || (common && a.schema?.toLowerCase().includes('common'))
                || (common && a.schema?.toLowerCase().includes('outside'))
                || (common && a.schema?.toLowerCase().includes('folder'))
                || (common && a.schema?.toLowerCase().includes('calendar'))
                || (common && a.schema?.toLowerCase().includes('energy'))
            ).sort(sortBySchema)
        }
    }, [basicFilteredItems, all, room, common, heat, ventilation, cool])


    const { activeHeatingGenerators, activeHeatingOutlets, activeHeatingPuffers, activeCoolingGenerators, activeCoolingOutlets, activeAHUs } = useMemo(() => {
        const activeHeatingGenerators = basicFilteredItems?.filter((a) => a.schema === schemaHeatingGen && a.isOn).length;
        const activeHeatingOutlets = basicFilteredItems?.filter((a) => (a.schema === schemaHeatingOutlet || a.schema === schemaHeatingCoolingOutlet ) && a.isOn).length;
        const activeHeatingPuffers = basicFilteredItems?.filter((a) => a.schema === schemaHeatingPuffer && a.isOn).length;

        const activeCoolingGenerators = basicFilteredItems?.filter((a) => a.schema === schemaCoolingGenerator && a.isOn).length;
        const activeCoolingOutlets = basicFilteredItems?.filter((a) => a.schema === schemaCoolinOutlet && a.isOn).length;

        const activeAHUs = basicFilteredItems?.filter((a) => a.schema === schemaAHU && a.isOn).length;
        return { activeHeatingGenerators, activeHeatingOutlets, activeHeatingPuffers, activeCoolingGenerators, activeCoolingOutlets, activeAHUs }
    }, [basicFilteredItems]);

    const activeHeatings = (activeHeatingGenerators ?? 0) + (activeHeatingOutlets ?? 0) + (activeHeatingPuffers ?? 0);
    const activeCoolings = (activeCoolingGenerators ?? 0) + (activeCoolingOutlets ?? 0);
    return (
        <>
            {!hideButtons &&
                <Block flexDirection='row' display='flex' marginBottom={theme.sizing.scale500} justifyContent='flex-start' gridGap={theme.sizing.scale100} overflow='auto' >
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={all} onClick={() => onAllChanged()}><FormattedMessage id="GroupSelection.All" defaultMessage="All" /></Button>
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={room} onClick={() => onRoomChanged()}><FormattedMessage id="GroupSelection.Room" defaultMessage="Roomautomation" /></Button>
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={heat} onClick={() => onHeatChanged()}>
                        <Block display={'inline-flex'} gridGap={theme.sizing.scale200}>
                            <FormattedMessage id="GroupSelection.Heat" defaultMessage="Heating" />
                            {activeHeatings > 0 && <NotificationCircle content={activeHeatings} color={'positive'} />}
                        </Block>
                    </Button>
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={cool} onClick={() => onCoolChanged()}>
                        <Block display={'inline-flex'} gridGap={theme.sizing.scale200}>
                            <FormattedMessage id="GroupSelection.Cool" defaultMessage="Cooling" />
                            {activeCoolings > 0 && <NotificationCircle content={activeCoolings} color={'positive'} />}
                        </Block>
                    </Button>
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={ventilation} onClick={() => onVentilationChanged()}>
                        <Block display={'inline-flex'} gridGap={theme.sizing.scale200}>
                            <FormattedMessage id="GroupSelection.Ventilation" defaultMessage="Ventilation" />
                            {(activeAHUs ?? 0) > 0 && <NotificationCircle content={activeAHUs} color={'positive'} />}
                        </Block>
                    </Button>
                    <Button kind={KIND.secondary} shape={SHAPE.pill} size={SIZE.mini} isSelected={common} onClick={() => onCommonChanged()}><FormattedMessage id="GroupSelection.Common" defaultMessage="Common" /></Button>
                </Block>
            }
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <AutomationObjectsFlexGridView noSort items={filterdItems ?? []}></AutomationObjectsFlexGridView>
            </LoadingView>
        </>
    )
}

const sortByDescription = (a: IAutomationObject, b: IAutomationObject) => {
    return a.description?.localeCompare(b.description);
}



const sortBySchema = (a: IAutomationObject, b: IAutomationObject) => {
    const appSortPrioA = sortPrios[a.schema] ?? 9999;
    const appSortPrioB = sortPrios[b.schema] ?? 9999;
    if (appSortPrioA > appSortPrioB)
        return 1;
    else if (appSortPrioA < appSortPrioB)
        return -1;

    return sortByDescription(a, b);

}
